import React from 'react';
import './Breadcrumbs.scss';

const Breadcrumbs = (props) => (
	<div>
		{props.paths &&
			props.paths.map((path, index) => {
				// Hack:
				// these come from the URL and are in title case
				// they aren't handled on the page level, I'll make this more flexible in the future
				// nc if else condition should be remove when deleting those pages
				if (path.label === 'Cds') {
					path.label = 'CDs';
				} else if (path.label === 'Ira') {
					path.label = 'IRAs';
				} else if (path.label === 'Checking Accounts Nc') {
					path.label = 'Checking Accounts';
				} else if (path.label === 'Savings Accounts Nc') {
					path.label = 'Savings Accounts';
				}
				return (
					<a className="bread-crumb-item" key={index} aria-label={path.label} href={path.href}>
						{path.label}
					</a>
				);
			})}
	</div>
);

export default Breadcrumbs;
